import React from 'react';
import { Box, Paper } from '@mui/material';
import { DefaultLayout } from '../../components/layout/default-layout';
import { useMetaTitle } from '../../hooks';
import { useFeatureToggles } from '../../feature-toggles';
import { PageNotFound } from '../../404';
import { WithUserScopedServiceProviderUnitCheck } from '../service-provider-unit-calendar/with-user-scoped-service-provider-unit-check';
import { UseOfForceUnitOverview } from './use-of-force-unit-overview';
import { useUdfoererAreaAccess } from '../citizen/serviceprovider/hooks/use-service-provider-area-access';

function ServiceProviderUseOfForceContent() {
  useMetaTitle('Magtanvendelser');

  return (
    <Box sx={{ px: 2, pt: 2 }}>
      <Paper elevation={0} sx={{ bgcolor: 'common.white', p: 2, borderRadius: 1 }}>
        <UseOfForceUnitOverview />
      </Paper>
    </Box>
  );
}

export function ServiceProviderUseOfForcePage() {
  const { isFeatureEnabled } = useFeatureToggles();
  const hasUdfoererAreaAccess = useUdfoererAreaAccess();

  if (!isFeatureEnabled('ShowUseOfForce') || !hasUdfoererAreaAccess) {
    return <PageNotFound />;
  }

  return (
    <DefaultLayout>
      <WithUserScopedServiceProviderUnitCheck>
        <ServiceProviderUseOfForceContent />
      </WithUserScopedServiceProviderUnitCheck>
    </DefaultLayout>
  );
}
